var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2DarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25405",
    d: "M2 4L21 5V20H2V4Z",
    fill: "url(#paint0_linear_744_894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25404",
    d: "M20 8.75V6.89197C20 5.83051 19.1708 4.95393 18.1109 4.89505L4.11094 4.11727C2.96454 4.05359 2 4.96602 2 6.11419V18C2 19.1046 2.89543 20 4 20H18C19.1046 20 20 19.1046 20 18V15.5",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25403",
    x: 11,
    y: 9,
    width: 11,
    height: 6,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_894",
    x1: 4.03571,
    y1: 4,
    x2: 17.8478,
    y2: 22.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2DarkActive);
export default __webpack_public_path__ + "static/media/l2-dark-active.cceb6c56909c976bed5f2b8caaeca6cb.svg";
export { ForwardRef as ReactComponent };